import React, { useState } from 'react';

import AuthPanel from '../components/auth/AuthPanel';
import { useAuth } from '../context/AuthContext';
import { authApi } from '../services/api';

function AdminInviteView() {
  const { handleProtectedRequest } = useAuth();

  const [email, setEmail] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [inviteUrl, setInviteUrl] = useState('');
  const [copyMessage, setCopyMessage] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setErrorMessage('');
    setCopyMessage('');
    setIsSubmitting(true);

    try {
      const response = await handleProtectedRequest(() => authApi.createInvite({ email }));
      setInviteUrl(response?.inviteURL || '');
    } catch (error) {
      setErrorMessage(error.message || 'Unable to create an invite right now.');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCopy = async () => {
    if (!inviteUrl) {
      return;
    }

    try {
      await navigator.clipboard.writeText(inviteUrl);
      setCopyMessage('Invite link copied.');
    } catch (error) {
      setCopyMessage('Copy was not available. You can still copy the link manually below.');
    }
  };

  return (
    <AuthPanel
      eyebrow="Admin"
      title="Create an invite"
      description="Generate a registration link for a specific email address. Share the returned link directly with that person."
      width="wide"
    >
      {errorMessage && (
        <div className="alert alert-danger mt-4 mb-0" role="alert">
          {errorMessage}
        </div>
      )}

      <form className="auth-panel-form" onSubmit={handleSubmit}>
        <div>
          <label className="auth-panel-label" htmlFor="invite-email">
            Invite email
          </label>
          <input
            autoComplete="email"
            className="form-control auth-panel-input"
            id="invite-email"
            onChange={(event) => setEmail(event.target.value)}
            placeholder="coach@example.com"
            required
            type="email"
            value={email}
          />
        </div>

        <div className="auth-panel-inline-actions">
          <button
            className="btn btn-dark auth-panel-submit"
            disabled={isSubmitting}
            type="submit"
          >
            {isSubmitting ? 'Creating Invite...' : 'Create Invite'}
          </button>
        </div>
      </form>

      {inviteUrl && (
        <div className="auth-panel-stack">
          <div className="alert alert-success mb-0" role="status">
            Invite created successfully.
          </div>

          <div className="auth-panel-url-shell">
            <label className="auth-panel-label" htmlFor="invite-link">
              Invite link
            </label>
            <div className="input-group">
              <input
                className="form-control auth-panel-url-input"
                id="invite-link"
                readOnly
                type="text"
                value={inviteUrl}
              />
              <button
                className="btn btn-outline-dark auth-panel-copy-button"
                onClick={handleCopy}
                type="button"
              >
                Copy Link
              </button>
            </div>
            <p className="auth-panel-status-note">
              {copyMessage || 'Keep this link handy so you can share it with the invited user.'}
            </p>
          </div>
        </div>
      )}
    </AuthPanel>
  );
}

export default AdminInviteView;
